function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Background",
  d: "M138,30a4,4,0,0,0-8,0H15A15,15,0,0,1,15,0H130a4,4,0,0,0,4,4,4,4,0,0,0,4-4h64a15,15,0,0,1,0,30Z",
  transform: "translate(0.5 0.5)",
  fill: "rgba(132,185,217,0.6)",
  stroke: "#75a9bc",
  strokeWidth: 1,
  fillRule: "evenodd",
  opacity: 0.8
});

var SvgGenealogyGrandfather = function SvgGenealogyGrandfather(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 218,
    height: 31,
    viewBox: "0 0 218 31",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGenealogyGrandfather, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/genealogy-grandfather.a87fe972.svg";
export { ForwardRef as ReactComponent };